import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/Select"

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
// Feb allows 29 — these are recurring annual dates, so leap years must be pickable.
const DAYS_IN_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

// Recurring annual date (month + day, no year). Picking a month that can't
// hold the current day clears the day.
export default function MonthDayPicker({ month, day, onChange, disabled, label }: {
  month: number | null
  day: number | null
  onChange: (next: { month: number; day: number | null }) => void
  disabled: boolean
  label: string
}) {
  const maxDay = month ? DAYS_IN_MONTH[month - 1] : 31

  return (
    <>
      <Select
        value={month ? String(month) : undefined}
        onValueChange={(v) => {
          const m = Number(v)
          onChange({ month: m, day: day && day > DAYS_IN_MONTH[m - 1] ? null : day })
        }}
        disabled={disabled}
      >
        <SelectTrigger className="w-24" aria-label={`${label} month`}>
          <SelectValue placeholder="Month" />
        </SelectTrigger>
        <SelectContent>
          {MONTHS.map((name, i) => (
            <SelectItem key={name} value={String(i + 1)}>{name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select
        value={day ? String(day) : undefined}
        onValueChange={(v) => onChange({ month: month!, day: Number(v) })}
        disabled={disabled || !month}
      >
        <SelectTrigger className="w-20" aria-label={`${label} day`}>
          <SelectValue placeholder="Day" />
        </SelectTrigger>
        <SelectContent>
          {Array.from({ length: maxDay }, (_, i) => (
            <SelectItem key={i + 1} value={String(i + 1)}>{i + 1}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  )
}
